import { Routes, Route } from 'react-router-dom';
import { ComponentExplorerRoutes } from '@modules/component-explorer';
import { AdminRoutes } from '@modules/admin';
import { ClaimFlowRoutes } from '@modules/claimflow';
import { ExtranetRoutes } from '@modules/extranet';
import { ConfigClickHandler } from '@components/shared/configurable';

function HomePage() {
  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-primary-600 mb-4">Kusudama</h1>
        <p className="text-secondary-600">Welcome to your new React application</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <>
      {/*
        Mounted once at the app root so the document-level CMD/Ctrl+click
        capture and CMD+Shift+E keyboard shortcut are always available
        inside React Router's context. The handler is a no-op for
        non-admin users — see `useIsConfigModeEligible` in
        `@components/shared/configurable`.
      */}
      <ConfigClickHandler />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/component-explorer/*" element={<ComponentExplorerRoutes />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/claimflow/:tenantSlug/*" element={<ClaimFlowRoutes />} />
        <Route path="/extranet/:tenantSlug/*" element={<ExtranetRoutes />} />
      </Routes>
    </>
  );
}

export default App;
